<template>
  <b-sidebar
    id="add-new-item-group-sidebar"
    :visible="isAddNewItemGroupSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => $emit('update:is-add-new-item-group-sidebar-active', val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Add New Item Group</h5>

        <feather-icon class="ml-1 cursor-pointer" icon="XIcon" size="16" @click="hide" />
      </div>

      <!-- BODY -->
      <div class="p-2">
        <item-group-form :form-data.sync="formData" :loading="isSubmitting" @submit="onSubmit" />
      </div>
    </template>
  </b-sidebar>
</template>

<script>
import { BSidebar } from 'bootstrap-vue';
import { ref, watch } from '@vue/composition-api';
import store from '@/store';
import ItemGroupForm from './ItemGroupForm.vue';

export default {
  name: 'ItemGroupListAddNew',
  components: {
    BSidebar,
    ItemGroupForm,
  },
  props: {
    isAddNewItemGroupSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  setup(props, { emit, root }) {
    const isSubmitting = ref(false);
    const formData = ref({
      id: 0,
      parentID: null,
      code: '',
      name: '',
      groupType: 'D',
      itemType: '',
      isActive: true,
      businessID: store.state.user.businessID,
    });

    const resetForm = () => {
      formData.value = {
        id: 0,
        parentID: null,
        code: '',
        name: '',
        groupType: 'D',
        itemType: '',
        isActive: true,
        businessID: store.state.user.businessID,
      };
    };

    // Watch for sidebar open/close to reset form
    watch(
      () => props.isAddNewItemGroupSidebarActive,
      (isOpen) => {
        if (isOpen) {
          // Reset form when sidebar opens
          resetForm();
        }
      }
    );

    const onSubmit = async (submittedData) => {
      console.log('=== Item Group Add On Submit', JSON.stringify(submittedData, null, 2));

      isSubmitting.value = true;

      try {
        // Use the submitted data instead of formData
        const dataToSubmit = {
          ...submittedData,
          businessID: store.state.user.businessID,
        };

        const response = await store.dispatch('fbr-invoice-item-group/addItemGroup', dataToSubmit);

        console.log('=== Item Group Add On Submit Response', JSON.stringify(response, null, 2));

        if (response.data.status === 'success') {
          root.$bvToast.toast('Item Group added successfully', {
            title: 'Success',
            variant: 'success',
            solid: true,
          });
        } else {
          root.$bvToast.toast(response.data.message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          });
        }
        // Show success toast

        // Reset form data to clear all fields
        resetForm();

        // Close sidebar and refetch data
        emit('update:is-add-new-item-group-sidebar-active', false);
        emit('refetch-data');
      } catch (error) {
        console.error('Error adding item group:', error);

        // Show user-friendly error message
        let errorMessage = 'Error adding item group. Please try again.';

        if (error.response && error.response.data && error.response.data.message) {
          errorMessage = error.response.data.message;
        }

        // Show error toast
        root.$bvToast.toast(errorMessage, {
          title: 'Error',
          variant: 'danger',
          solid: true,
        });
      } finally {
        isSubmitting.value = false;
      }
    };

    return {
      isSubmitting,
      formData,
      onSubmit,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
#add-new-item-group-sidebar {
  .content-sidebar-header {
    padding: 1rem 1.5rem !important;
  }
}
</style>
